import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Button, Form, Input, List, Toast } from 'antd-mobile-v5'
import { useHistory } from 'react-router-dom'
import { FormattedMessage, useIntl } from 'react-intl'
import { WhiteSpace, WingBlank } from 'antd-mobile'
import {
  formatDate,
  getSubmitOssFormat,
  removeExpires,
  specialtyCd,
  specialtyMapping,
} from '../../components/common/utils'
import { getCookie } from '../../components/common/cookie'
import Header from '../../components/FormTools/FormHeader'
import SearchStoreInfo from '../../components/FormTools/SearchStoreInfo'
import DatePickerTool from '../../components/FormTools/DatePicker'
import UploadOssFile from '../../components/FormTools/UploadOssFile'
import Signature from '../../components/FormTools/Signature'
import DiverInfo from '../../components/FormTools/DiverInfo'
import dayjs from 'dayjs'
import { useReSubmitCdSiApp } from '../../services/hooks'

const Item = List.Item

const CdSiAppDetail = () => {
  const { ossSignature, detail } = useSelector((state) => ({
    ossSignature: state.oss.ossSignature,
    detail: state.ui.siDetailInProcess,
  }))

  const { push } = useHistory()
  const lang = getCookie('language')
  const [form] = Form.useForm()
  const { formatMessage } = useIntl()
  const [storeVerify, setStoreVerify] = useState(false)
  const [signature, setSignature] = useState('')

  const { runAsync: reSubmit, loading } = useReSubmitCdSiApp()

  useEffect(() => {
    if (detail) {
      form.setFieldsValue({
        attachFile: detail.attachFile || [],
        courseLocation: detail.courseLocation || '',
        courseDate: new Date(detail.courseDate) || '',
      })
      setSignature(detail.handwrittenSignatureUrlCD)
    }
  }, [detail])

  const submitSiApp = async () => {
    await form.validateFields()
    if (!signature) {
      Toast.show({
        content: formatMessage({ id: 'dm-form-signature-confirm' }),
      })
      return
    }
    const values = form.getFieldsValue(true)
    const { storeNumber, courseDate, attachFile, ...data } = values
    const { status, credentialId, code } = detail
    let newData = {
      ...data,
      courseDate: formatDate(courseDate, 'YYYY-MM-DD'),
      handwrittenSignatureUrlCD: getSubmitOssFormat(signature),
      status,
      credentialId,
      code,
    }
    if (detail.attachFile) {
      newData.attachFile = removeExpires(attachFile)
    }
    if (storeVerify) newData.storeNumber = storeNumber
    reSubmit(newData).then((res) => {
      if (res.code) {
        Toast.show({
          icon: 'success',
          content: '提交成功',
          afterClose: () => {
            push('/cdAppList')
          },
        })
      } else {
        Toast.show({
          icon: 'fail',
          content: '提交失败',
        })
      }
    })
  }

  const getApplicableList = () => {
    return specialtyCd.filter((item) => item.spi === detail.credentialId)
  }

  const fileName = (type) => `${ossSignature.dir}${type}/${new Date().getTime()}`

  if (!detail) return null

  const editable = detail.status === 'ADMIN_NOT_APPROVED'
  return (
    <>
      <Header text={<FormattedMessage id="si-form-title" />} code={detail?.code} />
      <DiverInfo
        info={{
          englishName: detail.instructorInfoDTO.instructorName,
          affiliateId: detail.instructorInfoDTO.affiliateId,
          email: detail.instructorInfoDTO.email,
          birthDate: detail.instructorInfoDTO.birthDate,
        }}
      />
      <Form form={form} validateTrigger="onSubmit">
        <Form.Header>课程信息</Form.Header>
        {detail.storeInfoDTO && (
          <SearchStoreInfo
            form={form}
            setStoreVerify={setStoreVerify}
            storeVerify={storeVerify}
            editable={false}
            initStoreInfo={detail.storeInfoDTO}
          />
        )}
        <Form.Item
          form={form}
          name="courseLocation"
          label={formatMessage({ id: 'si-course-location-title' })}
          rules={[
            {
              required: true,
              message: formatMessage({ id: 'si-course-location' }),
            },
          ]}
        >
          <Input disabled={true} />
        </Form.Item>
        <DatePickerTool
          name="courseDate"
          placeholder={formatMessage({ id: 'efri-course-date-error' })}
          disabled={true}
          label={formatMessage({ id: 'common-course-date' })}
          rules={[
            {
              required: true,
              message: formatMessage({ id: 'efri-course-date-error' }),
            },
          ]}
          max={dayjs().toDate()}
        />
        {detail.attachFile ? (
          getApplicableList().map((item) => (
            <>
              <Form.Header>
                <FormattedMessage id="si-upload-attach" />
              </Form.Header>
              <Form.Item
                name="attachFile"
                label={specialtyMapping[item.spi][lang]}
                form={form}
                rules={[
                  {
                    required: true,
                    message: formatMessage({ id: 'form-upload-error' }),
                  },
                ]}
              >
                <UploadOssFile
                  form={form}
                  fileName={fileName(item.spi)}
                  ossSignature={ossSignature}
                  onSuccess={(file) => form.setFieldsValue({ attachFile: file })}
                  editable={editable}
                  fileList={form.getFieldValue('attachFile')}
                  tips={item.desc[lang]}
                />
              </Form.Item>
            </>
          ))
        ) : (
          <>
            <Form.Header>
              <FormattedMessage id="si-sp-app" />
            </Form.Header>
            <Item>{specialtyMapping[detail.credentialId][lang]}</Item>
          </>
        )}
      </Form>
      <WhiteSpace />
      <Signature
        title={formatMessage({ id: 'dm-form-signature' })}
        filePath={'signature'}
        modified={editable}
        oss={ossSignature}
        onSuccess={(imgUrl) => setSignature(imgUrl)}
        onClear={() => setSignature('')}
        initSignature={detail.handwrittenSignatureUrlCD}
      />
      <WhiteSpace size="xl" />
      {editable && (
        <WingBlank>
          <Button color="primary" loading={loading} block onClick={() => submitSiApp()}>
            <FormattedMessage id="dm-form-submit" />
          </Button>
        </WingBlank>
      )}
      <WhiteSpace size="xl" />
    </>
  )
}

export default CdSiAppDetail
